export function replaceNonAlphanumeric(query?: string): string {
  if (!query) return '';

  return query.replaceAll(/[\W_]+/g, '');
}
